import type { ChangeEvent } from "react";

import { formatDisplayValue } from "@/shared/utils/estateItemLabels";

export function currencyInput(value: string, onChange: (val: string) => void) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value.replace(/[^0-9.,]/g, "").replace(/,/g, "");
    const parts = input.split(".");
    if (parts.length > 2) return;
    if (parts[1] && parts[1].length > 2) return;
    onChange(input);
  };

  return { handleChange, displayValue: formatDisplayValue(value) };
}
